import React from 'react';

interface DetailRowProps {
    label: string;
    children: React.ReactNode;
}

export const DetailRow: React.FC<DetailRowProps> = ({ label, children }) => (
    <div className="flex flex-col gap-s1 sm:flex-row sm:items-center sm:justify-between sm:gap-s3">
        <dt className="text-sm font-medium text-muted">{label}</dt>
        <dd className="text-sm text-default sm:text-right">{children}</dd>
    </div>
);
